import React from 'react'
import Ngopage from '../landing/NGOs/ngos'

export default function Ngo() {
    return (
        <div style={{marginTop: '120px'}}>
            <Ngopage/>
        </div>
    )
}
